import {Injectable} from '@angular/core';
import {DbDateStruct} from '../date-struct';
import {isInteger} from '../../util/util';

export function NGB_DATEPICKER_DATE_ADAPTER_FACTORY() {
  return new NgbDateStructAdapter();
}

/**
 * An abstract service that does the conversion between the internal datepicker `DbDateStruct` model and
 * any provided user date model `D`, ex. a string, a native date, etc.
 *
 * The adapter is used **only** for conversion when binding datepicker to a form control,
 * ex. `[(ngModel)]="userDateModel"`. Here `userDateModel` can be of any type.
 *
 * The default datepicker implementation assumes we use `DbDateStruct` as a user model.
 *
 * See the [date format overview](#/components/datepicker/overview#date-model) for more details
 * and the [custom adapter demo](#/components/datepicker/examples#adapter) for an example.
 */
@Injectable({providedIn: 'root', useFactory: NGB_DATEPICKER_DATE_ADAPTER_FACTORY})
export abstract class NgbDateAdapter<D> {
  /**
   * Converts a user-model date of type `D` to an `DbDateStruct` for internal use.
   */
  abstract fromModel(value: D | null): DbDateStruct | null;

  /**
   * Converts an internal `DbDateStruct` date to a user-model date of type `D`.
   */
  abstract toModel(date: DbDateStruct | null): D | null;
}

@Injectable()
export class NgbDateStructAdapter extends NgbDateAdapter<DbDateStruct> {
  /**
   * Converts a DbDateStruct value into DbDateStruct value
   */
  fromModel(date: DbDateStruct | null): DbDateStruct | null {
    return (date && isInteger(date.year) && isInteger(date.month) && isInteger(date.day)) ?
        {year: date.year, month: date.month, day: date.day} :
        null;
  }

  /**
   * Converts a DbDateStruct value into DbDateStruct value
   */
  toModel(date: DbDateStruct | null): DbDateStruct | null {
    return (date && isInteger(date.year) && isInteger(date.month) && isInteger(date.day)) ?
        {year: date.year, month: date.month, day: date.day} :
        null;
  }
}
